module.exports = __webpack_public_path__ + "img/footer_bg.0ce59636.png";